import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";import useTooltip from '~/hooks/useTooltip'
import CardButton from '../../../../components/CardButton'
import IconLabel from '../../../../components/IconLabel'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'


import lazyPreload from '../../../../utils/lazyPreload'

const TaskFooterIntegrateMenuRoot = lazyPreload(
  () =>
    import(
      /* webpackChunkName: 'TaskFooterIntegrateMenuRoot' */ '../../../../components/TaskFooterIntegrateMenuRoot'
    )
)







const TaskFooterIntegrateToggle = (props) => {
  const {mutationProps, task, useTaskChild} = props
  const {togglePortal, originRef, menuPortal, menuProps, loadingWidth, loadingDelay} = useMenu(
    MenuPosition.UPPER_RIGHT,
    {
      loadingWidth: 200
    }
  )
  const {
    tooltipPortal,
    openTooltip,
    closeTooltip,
    originRef: tipRef
  } = useTooltip(MenuPosition.UPPER_CENTER)
  return (
    _jsxs(_Fragment, { children: [
      _jsx(CardButton, {
        onClick: togglePortal,
        ref: originRef,
        onMouseEnter: TaskFooterIntegrateMenuRoot.preload,
 children: 
        _jsx(IconLabel, {
          icon: "widgets",
          onMouseEnter: openTooltip,
          onMouseLeave: closeTooltip,
          onClick: closeTooltip,
          ref: tipRef,}
        )
      })
      , tooltipPortal(_jsx('div', { children: 'Push to Integration'}))
      , menuPortal(
        _jsx(TaskFooterIntegrateMenuRoot, {
          menuProps: menuProps,
          loadingDelay: loadingDelay,
          loadingWidth: loadingWidth,
          mutationProps: mutationProps,
          task: task,
          useTaskChild: useTaskChild,}
        )
      )
    ]})
  )
}

export default TaskFooterIntegrateToggle
